var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_27615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8713 6.37876L21.6213 1.12876C21.5395 1.04767 21.4425 0.983509 21.3359 0.939965C21.2293 0.896421 21.1152 0.874349 21 0.875015H19.25V7.87502C19.25 8.33914 19.0656 8.78426 18.7374 9.11245C18.4092 9.44064 17.9641 9.62502 17.5 9.62502H10.5C10.0359 9.62502 9.59075 9.44064 9.26256 9.11245C8.93437 8.78426 8.75 8.33914 8.75 7.87502V0.875015H3.5C2.80381 0.875015 2.13613 1.15158 1.64384 1.64386C1.15156 2.13614 0.875 2.80382 0.875 3.50001V24.5C0.875 25.1962 1.15156 25.8639 1.64384 26.3562C2.13613 26.8485 2.80381 27.125 3.5 27.125H5.25V19.25C5.25 18.5538 5.52656 17.8861 6.01884 17.3939C6.51113 16.9016 7.17881 16.625 7.875 16.625H20.125C20.8212 16.625 21.4889 16.9016 21.9812 17.3939C22.4734 17.8861 22.75 18.5538 22.75 19.25V27.125H24.5C25.1962 27.125 25.8639 26.8485 26.3562 26.3562C26.8484 25.8639 27.125 25.1962 27.125 24.5V7.00001C27.1257 6.88486 27.1036 6.7707 27.0601 6.6641C27.0165 6.55749 26.9523 6.46052 26.8713 6.37876Z",
    fill: "#FD9468"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5 0.875H17.5V7.875H10.5V0.875Z",
    fill: "#FD9468"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.125 18.375H7.875C7.64294 18.375 7.42038 18.4672 7.25628 18.6313C7.09219 18.7954 7 19.0179 7 19.25V27.125H21V19.25C21 19.0179 20.9078 18.7954 20.7437 18.6313C20.5796 18.4672 20.3571 18.375 20.125 18.375Z",
    fill: "#FD9468"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_27615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.4c996402857520f71de38db11c5b8a6e.svg";
export { ForwardRef as ReactComponent };